import type { Namespace } from "@/i18n/types";
import nsSideNavEN from "./en";
import nsSideNavJA from "./ja";

export const nsSideNav = {
  name: "sideNav",
  locales: {
    ja: nsSideNavJA,
    en: nsSideNavEN,
  },
} satisfies Namespace<"sideNav", typeof nsSideNavJA>;
